<template>
  <div>
    <div class="container p-3 mb-5 bg-white rounded">
      <p class="p-0 m-0 text-dark">
        1. Hoeveel woninginbraken zijn er gemiddeld per jaar in Nederland?
      </p>
    </div>
    <!-- ans -->
    <div class="fade-in">
      <p class="text-dark pl-4" @click="moveToNextStep">Correcte antwoord:</p>
      <div class="container pl-5">
        <div class="row mb-4" @click="moveToNextStep">
          <div class="cirkel">B</div>
          <p class="p-0 m-0 mt-1 text-left">23.000 inbraken per jaar</p>
        </div>
      </div>
      <div class="text-center mt-5">
        <b-button variant="light" size="md" @click="moveToNextStep">
          Volgende vraag »
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Step1Ans",
  methods: {
    moveToNextStep() {
      this.$emit("next");
    },
  },
};
</script>

<style></style>
